(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["buy-box"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initBuyBox(root) {
      var cfgEl = root.querySelector('[data-buybox-config]');
      if (!cfgEl) return;

      var cfg;
      try {
        cfg = JSON.parse(cfgEl.textContent);
      } catch (e) {
        return;
      }

      // Built via concatenation so the source contains no literal Liquid-looking braces.
      var DEFAULT_MONEY_FORMAT = '$' + '{' + '{amount}' + '}';

      var products = cfg.products || {};
      var moneyFormat = cfg.moneyFormat || DEFAULT_MONEY_FORMAT;
      var discount = Number(cfg.subscribeDiscount) || 20;
      var daysByTier = cfg.daysByTier || { '1': 30, '2': 60, '3': 90 };
      var flavorImages = cfg.flavorImages || {};

      // ---- Stage 3: per-flavor gallery filter (Model B, alt-text tags) ----
      // The gallery-image key is DERIVED mechanically from the flavor option value via flavorKey() (below),
      // so adding a flavor needs ZERO code change — just tag its images with that derived key. No lookup map.

      // ---- Money formatting (standard Shopify helper, driven by shop.money_format) ----
      function formatMoney(cents, format) {
        if (typeof cents === 'string') cents = cents.replace('.', '');
        var value = '';
        var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        var formatString = format || DEFAULT_MONEY_FORMAT;

        function formatWithDelimiters(number, precision, thousands, decimal) {
          precision = precision == null ? 2 : precision;
          thousands = thousands || ',';
          decimal = decimal || '.';
          if (isNaN(number) || number == null) return '0';
          number = (number / 100).toFixed(precision);
          var parts = number.split('.');
          var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
          var cents = parts[1] ? decimal + parts[1] : '';
          return dollars + cents;
        }

        var match = formatString.match(placeholderRegex);
        var token = match ? match[1] : 'amount';
        switch (token) {
          case 'amount': value = formatWithDelimiters(cents, 2); break;
          case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
          case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
          case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
          case 'amount_with_space_separator': value = formatWithDelimiters(cents, 2, ' ', ','); break;
          case 'amount_with_apostrophe_separator': value = formatWithDelimiters(cents, 2, "'", '.'); break;
          default: value = formatWithDelimiters(cents, 2);
        }
        return formatString.replace(placeholderRegex, value);
      }

      // Whole-dollar money (no cents) — swaps the money format's amount token for its no-decimals
      // variant, then reuses formatMoney. Falls back to the normal (2-decimal) format for exotic
      // money formats that have no no-decimals equivalent.
      var NO_DECIMALS_TOKEN = {
        'amount': 'amount_no_decimals',
        'amount_no_decimals': 'amount_no_decimals',
        'amount_with_comma_separator': 'amount_no_decimals_with_comma_separator',
        'amount_no_decimals_with_comma_separator': 'amount_no_decimals_with_comma_separator'
      };
      function formatMoneyWhole(cents) {
        var m = moneyFormat.match(/\{\{\s*(\w+)\s*\}\}/);
        var token = m ? m[1] : 'amount';
        var noDec = NO_DECIMALS_TOKEN[token];
        if (!noDec) return formatMoney(cents, moneyFormat);
        // Braces built via concatenation so the source has no literal Liquid-looking braces.
        var replacementToken = '{' + '{' + noDec + '}' + '}';
        return formatMoney(cents, moneyFormat.replace(/\{\{\s*\w+\s*\}\}/, replacementToken));
      }

      function normalize(str) {
        return String(str || '')
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .toLowerCase()
          .trim();
      }

      // Gallery-image flavor KEY \u2014 derived mechanically from the flavor option value (no lookup map).
      // Like normalize() but ALSO strips every non-alphanumeric (spaces, punctuation, hyphens), so:
      //   "Strawberry Lemonade" \u2192 strawberrylemonade,  "Pineapple Taj\u00edn" \u2192 pineappletajin,
      //   "Guava Colada" \u2192 guavacolada.  Deterministic (NFD accent-strip + lowercase + [^a-z0-9] removal).
      function flavorKey(str) {
        return String(str || '')
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '') // strip accent marks (\u00ed \u2192 i)
          .toLowerCase()
          .replace(/[^a-z0-9]/g, '');       // remove spaces, punctuation, hyphens
      }

      // ---- Derive flavor option index + ordered flavor list from base product (tier 1) ----
      var base = products['1'];
      if (!base) return; // nothing to drive

      function flavorIndex(product) {
        if (!product || !product.optionNames) return 0;
        for (var i = 0; i < product.optionNames.length; i++) {
          if (normalize(product.optionNames[i]) === 'flavor') return i;
        }
        return 0; // fall back to first option
      }

      var baseFlavorIdx = flavorIndex(base);
      var flavors = [];
      var seen = {};
      base.variants.forEach(function (v) {
        var name = v.options[baseFlavorIdx];
        var key = normalize(name);
        if (name && !seen[key]) {
          seen[key] = true;
          flavors.push(name);
        }
      });
      if (!flavors.length) return;

      // Find the variant for a given flavor within a given product (tier).
      function findVariant(product, flavorName) {
        if (!product) return null;
        var idx = flavorIndex(product);
        var target = normalize(flavorName);
        for (var i = 0; i < product.variants.length; i++) {
          if (normalize(product.variants[i].options[idx]) === target) return product.variants[i];
        }
        return null;
      }

      // ---- State ----
      var availableTiers = ['3', '2', '1'].filter(function (t) { return !!products[t]; });
      var state = {
        flavor: flavors[0],
        tier: availableTiers[0] || '1',
        mode: (cfg.defaults && cfg.defaults.mode) || 'subscribe'
      };
      // Default flavor = first AVAILABLE flavor in the default tier, if any.
      (function () {
        var prod = products[state.tier];
        for (var i = 0; i < flavors.length; i++) {
          var v = findVariant(prod, flavors[i]);
          if (v && v.available) { state.flavor = flavors[i]; break; }
        }
      })();

      // ---- DOM refs ----
      var els = {
        flavorName: root.querySelector('[data-flavor-name]'),
        swatches: root.querySelector('[data-flavor-swatches]'),
        supplies: root.querySelectorAll('[data-tier]'),
        modeBtns: root.querySelectorAll('[data-mode]'),
        cancelAnytime: root.querySelector('[data-cancel-anytime]'),
        freeShipping: root.querySelector('[data-free-shipping]'),
        priceCurrent: root.querySelector('[data-price-current]'),
        priceCompare: root.querySelector('[data-price-compare]'),
        savings: root.querySelector('[data-savings]'),
        idInput: root.querySelector('[data-variant-id-input]'),
        planInput: root.querySelector('[data-selling-plan-input]'),
        atc: root.querySelector('[data-atc]'),
        atcText: root.querySelector('[data-atc-text]')
      };

      // ---- Pricing helpers ----
      // Subscribe allocation (exact plan price) for a variant, matching the product's plan id.
      function subAllocation(product, variant) {
        if (!variant || !variant.sellingPlanAllocations || !variant.sellingPlanAllocations.length) return null;
        if (product && product.sellingPlanId != null) {
          for (var i = 0; i < variant.sellingPlanAllocations.length; i++) {
            if (variant.sellingPlanAllocations[i].sellingPlanId === product.sellingPlanId) {
              return variant.sellingPlanAllocations[i];
            }
          }
        }
        return variant.sellingPlanAllocations[0];
      }

      function subscribePrice(product, variant) {
        var alloc = subAllocation(product, variant);
        if (alloc && alloc.price != null) return alloc.price;
        return Math.round(variant.price * (1 - discount / 100)); // fallback
      }

      function subscribePlanId(product, variant) {
        var alloc = subAllocation(product, variant);
        if (alloc && alloc.sellingPlanId != null) return alloc.sellingPlanId;
        return product ? product.sellingPlanId : null; // may be null
      }

      // ---- Flavor swatches: BUILD ONCE (persistent nodes), then only TOGGLE state per render ----
      // Rebuilding the whole strip on every flavor change re-created all the <img> elements, forcing a
      // re-decode → a visible flash on mobile. Now the card buttons/imgs/labels/click-listeners are built
      // ONE time; render() calls the lightweight renderSwatches() below, which only updates the selected
      // (aria-pressed) and sold-out (data-soldout + corner badge) state on the existing nodes — no teardown.
      var swatchRefs = {}; // flavor -> { btn, badge } ; badge is added/removed by renderSwatches
      function buildSwatches() {
        els.swatches.innerHTML = ''; // ONCE, at init only — never on flavor change
        flavors.forEach(function (flavor) {
          // ONE bordered card per flavor. The <button> itself is the bordered card AND the click target;
          // the gummy (top) and name (bottom) are its direct children, stacked in a flex column via CSS.
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'crescent-buybox__swatch';
          btn.setAttribute('data-flavor', flavor);
          // aria-pressed / data-soldout are set by renderSwatches (state-dependent).

          // Gummy image — top of the card.
          var imgSrc = flavorImages[flavorKey(flavor)]; // derived key — matches the Liquid-generated map
          if (imgSrc) {
            var img = document.createElement('img');
            img.className = 'crescent-buybox__swatch-img';
            img.alt = flavor;
            img.loading = 'lazy';
            // Missing-asset guard: asset_url returns a URL even when the gummy PNG doesn't exist, so on a
            // 404 (or any load error) swap the broken img for the placeholder circle. Built once, so this
            // fires at most ONCE per image (first load), never on subsequent flavor changes. Listener
            // attached BEFORE .src so it can't miss the error event.
            img.addEventListener('error', function () {
              var phFb = document.createElement('span');
              phFb.className = 'crescent-buybox__swatch-img--ph';
              if (img.parentNode) img.parentNode.replaceChild(phFb, img);
            });
            img.src = imgSrc;
            btn.appendChild(img);
          } else {
            var ph = document.createElement('span');
            ph.className = 'crescent-buybox__swatch-img--ph';
            btn.appendChild(ph);
          }

          // Flavor name — INSIDE the card, beneath the gummy.
          var name = document.createElement('span');
          name.className = 'crescent-buybox__swatch-name';
          name.textContent = flavor;
          btn.appendChild(name);

          // Sold-out corner badge — created once; renderSwatches() adds/removes it as the tier changes.
          // It's absolutely positioned (top-left corner), so its DOM order among the card's children is
          // irrelevant to layout.
          var badge = document.createElement('span');
          badge.className = 'crescent-buybox__swatch-badge';
          badge.textContent = 'Sold Out';

          // Click listener bound ONCE (the button is never re-created).
          btn.addEventListener('click', function () {
            state.flavor = flavor;
            render();
          });

          els.swatches.appendChild(btn);
          swatchRefs[flavor] = { btn: btn, badge: badge };
        });
      }

      // ---- Render: flavor swatches (STATE ONLY — no innerHTML teardown, no node re-creation) ----
      function renderSwatches() {
        var prod = products[state.tier];
        flavors.forEach(function (flavor) {
          var refs = swatchRefs[flavor];
          if (!refs) return;
          var variant = findVariant(prod, flavor);
          var soldOut = !variant || !variant.available;

          // Selected: copper border + full-opacity contents follow via CSS on aria-pressed.
          refs.btn.setAttribute('aria-pressed', flavor === state.flavor ? 'true' : 'false');

          // Sold-out (can change with tier): toggle the attribute AND add/remove the persistent corner
          // badge on the CARD (the button). Absolute-positioned, so appending it doesn't shift the gummy/name.
          if (soldOut) {
            refs.btn.setAttribute('data-soldout', 'true');
            if (!refs.badge.parentNode) refs.btn.appendChild(refs.badge);
          } else {
            refs.btn.removeAttribute('data-soldout');
            if (refs.badge.parentNode) refs.badge.parentNode.removeChild(refs.badge);
          }
        });
      }

      // ---- Render: supply cards (price + per-day for the selected flavor in each tier) ----
      function renderSupplies() {
        els.supplies.forEach(function (card) {
          var tier = card.getAttribute('data-tier');
          var prod = products[tier];
          card.setAttribute('aria-pressed', tier === state.tier ? 'true' : 'false');

          var priceEl = card.querySelector('[data-supply-price]');
          var perDayEl = card.querySelector('[data-supply-perday]');

          if (!prod) {
            if (priceEl) priceEl.textContent = '—';
            if (perDayEl) perDayEl.textContent = '';
            return;
          }

          var variant = findVariant(prod, state.flavor);
          if (!variant) {
            if (priceEl) priceEl.textContent = '—';
            if (perDayEl) perDayEl.textContent = '';
            return;
          }

          // Card price reflects the active mode: subscribe (discounted) price when Subscribe is on,
          // otherwise the one-time price. Single price per card, no strikethrough — same subscribe
          // logic as the main price display.
          var cardPrice = state.mode === 'subscribe' ? subscribePrice(prod, variant) : variant.price;
          if (priceEl) priceEl.textContent = formatMoneyWhole(cardPrice); // whole dollars, no cents
          // Per-day derives from the same mode-appropriate price so the figures always agree.
          // Per-day KEEPS two decimals (formatMoney), unlike the whole-dollar prices above.
          var days = Number(daysByTier[tier]) || 30;
          var perDay = Math.round(cardPrice / days);
          if (perDayEl) perDayEl.textContent = formatMoney(perDay, moneyFormat) + ' / Day';
        });
      }

      // ---- Render: mode toggle ----
      function renderMode() {
        els.modeBtns.forEach(function (btn) {
          btn.setAttribute('aria-pressed', btn.getAttribute('data-mode') === state.mode ? 'true' : 'false');
        });
        // "Cancel anytime" and "Free shipping" are subscribe-only perks; hide both in one-time mode.
        // Same state.mode gate for both so they can never diverge. '' restores the stylesheet display;
        // 'none' removes the whole item (its bound "·" goes with it).
        if (els.cancelAnytime) {
          els.cancelAnytime.style.display = state.mode === 'subscribe' ? '' : 'none';
        }
        if (els.freeShipping) {
          els.freeShipping.style.display = state.mode === 'subscribe' ? '' : 'none';
        }
      }

      // ---- Render: big price + savings + hidden inputs + ATC availability ----
      function renderPriceAndCart() {
        var prod = products[state.tier];
        var variant = prod ? findVariant(prod, state.flavor) : null;

        if (els.flavorName) els.flavorName.textContent = state.flavor;

        // No variant for this flavor/tier → disable.
        if (!variant) {
          setCart(null, null, false, 'Unavailable');
          if (els.priceCurrent) els.priceCurrent.textContent = '';
          hide(els.priceCompare);
          hide(els.savings);
          return;
        }

        var oneTime = variant.price;
        var current, reference;

        if (state.mode === 'subscribe') {
          current = subscribePrice(prod, variant);
          // Pre-discount reference: compare-at if higher, else the one-time price.
          reference = Math.max(variant.compareAtPrice || 0, oneTime);
        } else {
          current = oneTime;
          reference = variant.compareAtPrice || 0;
        }

        if (els.priceCurrent) els.priceCurrent.textContent = formatMoneyWhole(current); // whole dollars

        if (reference > current) {
          els.priceCompare.textContent = formatMoneyWhole(reference); // whole dollars
          show(els.priceCompare);
          var saving = reference - current;
          els.savings.textContent = "You're saving " + formatMoneyWhole(saving); // whole dollars
          show(els.savings);
        } else {
          hide(els.priceCompare);
          hide(els.savings);
        }

        // Availability → ATC + selling plan.
        if (!variant.available) {
          setCart(variant.id, null, false, 'Sold Out');
          return;
        }

        var planId = null;
        if (state.mode === 'subscribe') {
          planId = subscribePlanId(prod, variant); // may be null → falls back to one-time add
        }
        setCart(variant.id, planId, true, 'ADD TO CART');
      }

      function setCart(variantId, planId, enabled, text) {
        if (els.idInput) {
          if (variantId == null) {
            els.idInput.value = '';
            els.idInput.disabled = true;
          } else {
            els.idInput.value = variantId;
            els.idInput.disabled = false;
          }
        }
        if (els.planInput) {
          if (planId == null) {
            els.planInput.value = '';
            els.planInput.disabled = true; // omitted from FormData → one-time
          } else {
            els.planInput.value = planId;
            els.planInput.disabled = false;
          }
        }
        if (els.atc) {
          if (enabled) {
            els.atc.removeAttribute('disabled');
            els.atc.removeAttribute('aria-disabled');
          } else {
            els.atc.setAttribute('disabled', 'disabled');
            els.atc.setAttribute('aria-disabled', 'true');
          }
        }
        if (els.atcText && text) els.atcText.textContent = text;
      }

      function show(el) { if (el) el.hidden = false; }
      function hide(el) { if (el) el.hidden = true; }

      // ---- Master render ----
      // Reassigned once the gallery is wired below; no-op until then so early calls are safe.
      var applyGalleryFilter = function () {};
      function render() {
        renderSwatches();
        renderSupplies();
        renderMode();
        renderPriceAndCart();
        applyGalleryFilter();
      }

      // ---- Wire events ----
      els.supplies.forEach(function (card) {
        if (card.getAttribute('data-unavailable') === 'true') return;
        card.addEventListener('click', function () {
          state.tier = card.getAttribute('data-tier');
          render();
        });
      });
      els.modeBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          state.mode = btn.getAttribute('data-mode');
          render();
        });
      });

      // ---- Product image gallery (Stage 3: per-flavor filter + hero-swap + thumbnail sync) ----
      var gWindow = root.querySelector('[data-gallery-window]');
      var gTrack = root.querySelector('[data-gallery-track]');
      var gThumbs = root.querySelectorAll('[data-gallery-thumb]');
      var gSlides = gTrack ? gTrack.querySelectorAll('.crescent-buybox__gallery-slide') : [];

      // Slides and thumbs are index-aligned: image i ↔ gSlides[i] ↔ gThumbs[i]. gSlides[0] is the hero.
      if (gTrack && gThumbs.length && gSlides.length === gThumbs.length) {
        var heroImg = gSlides[0].querySelector('.crescent-buybox__gallery-main-img');
        var heroThumbImg = gThumbs[0].querySelector('.crescent-buybox__gallery-thumb-img');

        // Capture each image's key + full/thumb src+alt ONCE from the server-rendered DOM (before any swap).
        var imgKey = [], imgFullSrc = [], imgFullAlt = [], imgThumbSrc = [], imgThumbAlt = [];
        for (var gi = 0; gi < gThumbs.length; gi++) {
          imgKey[gi] = flavorKey(gThumbs[gi].getAttribute('data-flavor-key')); // '' → universal
          var mImg = gSlides[gi].querySelector('.crescent-buybox__gallery-main-img');
          imgFullSrc[gi] = mImg ? mImg.getAttribute('src') : '';
          imgFullAlt[gi] = mImg ? mImg.getAttribute('alt') : '';
          var tImg = gThumbs[gi].querySelector('.crescent-buybox__gallery-thumb-img');
          imgThumbSrc[gi] = tImg ? tImg.getAttribute('src') : '';
          imgThumbAlt[gi] = tImg ? tImg.getAttribute('alt') : '';
        }

        var visibleOrder = []; // absolute image indices in visual (slider) order; [0] is always the hero
        var current = 0;
        var heroAbsIndex = 0;  // absolute image index the hero slide currently DISPLAYS (F[0]) — for the lightbox

        // Move the track to visible-position p and sync the active thumbnail. Clamped, no wrap.
        var goToSlide = function (p) {
          if (!visibleOrder.length) return;
          p = Math.max(0, Math.min(p, visibleOrder.length - 1));
          current = p;
          gTrack.style.transform = 'translateX(-' + (p * 100) + '%)'; // inert on desktop (CSS forces none)
          for (var i = 0; i < gThumbs.length; i++) {
            var isActive = (visibleOrder[p] === i);
            gThumbs[i].classList.toggle('is-active', isActive);
            if (isActive) gThumbs[i].setAttribute('aria-current', 'true');
            else gThumbs[i].removeAttribute('aria-current');
          }
        };

        // F = matching images (flavor-tagged OR universal), in upload order. The flavor key is derived
        // mechanically from the option value (no map). Universal (untagged) images always show; backstop
        // to ALL images if nothing matches, so the gallery is never blank.
        var buildFiltered = function () {
          var mapped = flavorKey(state.flavor); // derived key — always a string, never undefined
          var F = [], i;
          for (i = 0; i < gThumbs.length; i++) {
            if (imgKey[i] === '' || imgKey[i] === mapped) F.push(i); // universal OR matches this flavor
          }
          if (!F.length) { for (i = 0; i < gThumbs.length; i++) F.push(i); } // backstop: never blank
          return F;
        };

        // Reassign the outer hook — render() calls this on every flavor/tier/mode change.
        applyGalleryFilter = function () {
          var F = buildFiltered();
          var f0 = F[0]; // the flavor's hero = first matching image (may NOT be image 0)
          heroAbsIndex = f0; // remember what the hero displays, so the lightbox opens THIS image

          // 1. Hero pouch shows F[0]; the hero thumbnail mirrors it. Background + benefit cards untouched.
          if (heroImg) { heroImg.setAttribute('src', imgFullSrc[f0]); heroImg.setAttribute('alt', imgFullAlt[f0]); }
          if (heroThumbImg) { heroThumbImg.setAttribute('src', imgThumbSrc[f0]); heroThumbImg.setAttribute('alt', imgThumbAlt[f0]); }

          // 2 + 3. Album = F[1..]. Hide non-matching AND F[0]'s own slide/thumb (de-dupe, so the promoted
          //         image never appears twice). The hero slide/thumb (index 0) always stay and represent F[0].
          visibleOrder = [0];
          for (var i = 1; i < gSlides.length; i++) {
            var inAlbum = (i !== f0) && (F.indexOf(i) !== -1);
            gSlides[i].classList.toggle('is-hidden', !inAlbum);
            gThumbs[i].classList.toggle('is-hidden', !inAlbum);
            if (inAlbum) visibleOrder.push(i);
          }
          gSlides[0].classList.remove('is-hidden');
          gThumbs[0].classList.remove('is-hidden');

          // 4. Reset to the first image of the filtered set — mobile track + desktop grid (reflows).
          goToSlide(0);
        };

        // Thumb click → that image's visible position (hidden thumbs can't be clicked).
        gThumbs.forEach(function (thumb, i) {
          thumb.addEventListener('click', function () {
            var pos = visibleOrder.indexOf(i);
            if (pos !== -1) goToSlide(pos);
          });
        });

        // Touch-swipe on the window — same goToSlide, stepping through the visible set.
        if (gWindow) {
          var sx = 0, sy = 0, lx = 0, ly = 0, tracking = false;
          gWindow.addEventListener('touchstart', function (e) {
            var t = e.changedTouches[0];
            sx = lx = t.clientX; sy = ly = t.clientY; tracking = true;
          }, { passive: true });
          gWindow.addEventListener('touchmove', function (e) {
            if (!tracking) return;
            var t = e.changedTouches[0];
            lx = t.clientX; ly = t.clientY;
          }, { passive: true });
          gWindow.addEventListener('touchend', function () {
            if (!tracking) return;
            tracking = false;
            var dx = lx - sx, dy = ly - sy;
            // Only a swipe if it clears the threshold AND is clearly more horizontal than vertical
            // (so vertical page scrolling is never hijacked).
            if (Math.abs(dx) < 40 || Math.abs(dx) <= Math.abs(dy)) return;
            goToSlide(current + (dx < 0 ? 1 : -1)); // left → next, right → prev
          }, { passive: true });
        }

        // ---- Desktop-only lightbox (native <dialog>): click any VISIBLE gallery image → full-size modal ----
        // Uses the already-captured full-res arrays (imgFullSrc/imgFullAlt). Gated to ≥990px so mobile taps
        // never open it — mobile keeps its slider untouched. Filtered-out slides are display:none (see
        // is-hidden), so they can't be clicked; the hero opens whatever image it currently shows (heroAbsIndex).
        var lightbox = root.querySelector('[data-lightbox-modal]');
        var lightboxImg = lightbox ? lightbox.querySelector('[data-lightbox-img]') : null;
        var isDesktop = function () { return window.matchMedia('(min-width: 990px)').matches; };
        if (lightbox && lightboxImg && typeof lightbox.showModal === 'function') {
          var openLightbox = function (absIndex) {
            if (absIndex == null || !imgFullSrc[absIndex]) return;
            lightboxImg.setAttribute('src', imgFullSrc[absIndex]);          // full-res, not the thumbnail
            lightboxImg.setAttribute('alt', imgFullAlt[absIndex] || '');
            lightbox.showModal();
          };
          gSlides.forEach(function (slide, i) {
            var frame = slide.querySelector('.crescent-buybox__gallery-frame');
            if (!frame) return;
            frame.addEventListener('click', function () {
              if (!isDesktop()) return; // desktop only — mobile main-image taps do nothing (slider unchanged)
              openLightbox(i === 0 ? heroAbsIndex : i); // hero shows F[0]=heroAbsIndex; other tiles show image i
            });
          });
          lightbox.querySelectorAll('[data-lightbox-close]').forEach(function (el) {
            el.addEventListener('click', function () { lightbox.close(); }); // X button
          });
          lightbox.addEventListener('click', function (e) {
            if (e.target === lightbox) lightbox.close(); // click on the dimmed backdrop closes
          });
          // Escape key is handled natively by <dialog> (cancel → close).
        }
      }

      // ---- Guarantee modal (native <dialog>, top layer) ----
      var gModal = root.querySelector('[data-guarantee-modal]');
      var gTrigger = root.querySelector('[data-guarantee-trigger]');
      if (gModal && gTrigger && typeof gModal.showModal === 'function') {
        gTrigger.addEventListener('click', function () {
          gModal.showModal();
        });
        gModal.querySelectorAll('[data-guarantee-close]').forEach(function (el) {
          el.addEventListener('click', function () { gModal.close(); });
        });
        // Click on the backdrop (outside the dialog box) closes it.
        gModal.addEventListener('click', function (e) {
          if (e.target === gModal) gModal.close();
        });
      }

      // ---- HSA/FSA (Truemed) info modal (native <dialog>, top layer) ----
      // Only present in states B and C; in state A the query returns null and this is skipped.
      var tmModal = root.querySelector('[data-hsafsa-modal]');
      var tmTrigger = root.querySelector('[data-hsafsa-trigger]');
      if (tmModal && tmTrigger && typeof tmModal.showModal === 'function') {
        tmTrigger.addEventListener('click', function () {
          tmModal.showModal();
        });
        tmModal.querySelectorAll('[data-hsafsa-close]').forEach(function (el) {
          el.addEventListener('click', function () { tmModal.close(); });
        });
        // Click on the backdrop (outside the dialog box) closes it.
        tmModal.addEventListener('click', function (e) {
          if (e.target === tmModal) tmModal.close();
        });
        // Two-tab switch (our pill/toggle pattern): aria-selected drives the pill fill; panels toggle via [hidden].
        var tmTabs = tmModal.querySelectorAll('[data-hsafsa-tab]');
        var tmPanels = tmModal.querySelectorAll('[data-hsafsa-panel]');
        tmTabs.forEach(function (tab) {
          tab.addEventListener('click', function () {
            var key = tab.getAttribute('data-hsafsa-tab');
            tmTabs.forEach(function (t) {
              var on = t === tab;
              t.setAttribute('aria-selected', on ? 'true' : 'false');
              t.tabIndex = on ? 0 : -1;
            });
            tmPanels.forEach(function (p) {
              p.hidden = p.getAttribute('data-hsafsa-panel') !== key;
            });
          });
        });
      }

      buildSwatches(); // build the persistent swatch nodes ONCE, before the first state render
      render();
    }

    function initAll() {
      document.querySelectorAll('.crescent-buybox[data-buybox]').forEach(initBuyBox);
    }

    // ---- Quick-questions accordion — same approach as sections/faq.liquid: aria-expanded + .is-open,
    //      MULTIPLE open at once, document-delegated so it needs no per-instance binding. ----
    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('.crescent-buybox__qa-trigger');
      if (!trigger) return;
      var expanded = trigger.getAttribute('aria-expanded') === 'true';
      trigger.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      var item = trigger.closest('.crescent-buybox__qa-item');
      if (item) item.classList.toggle('is-open', !expanded);
    });

    // ---- Quick-questions jump links → smooth-scroll to the target homepage section. Guarded: if the
    //      target id isn't on this template the default is left alone (no-op). Respects reduced-motion. ----
    document.addEventListener('click', function (event) {
      var jump = event.target.closest('.crescent-buybox__qa-jump');
      if (!jump) return;
      var href = jump.getAttribute('href') || '';
      if (href.charAt(0) !== '#' || href.length < 2) return;
      var target = document.getElementById(href.slice(1));
      if (!target) return;
      event.preventDefault();
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["creatine-gap"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      var mq = window.matchMedia('(min-width: 990px)');
      document.querySelectorAll('.creatine-gap__details').forEach(function (details) {
        var summary = details.querySelector('.creatine-gap__summary');
        // Desktop (>=990px): keep the disclosure permanently open and non-collapsible so toggling can't
        // re-center the vertically-centered right column. Mobile (<990px): native accordion, untouched.
        if (summary) {
          summary.addEventListener('click', function (e) { if (mq.matches) e.preventDefault(); });
        }
        details.addEventListener('toggle', function () {
          if (mq.matches && !details.open) details.open = true; // safety net (keyboard/programmatic close)
        });
        function sync() { if (mq.matches) details.open = true; }
        sync();
        mq.addEventListener('change', sync);
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["crescent-header"] && !Shopify.designMode) return;
  try {
    
  /* Nav drawer open/close. Scoped per .crescent-header instance; multi-instance safe. */
  (function () {
    function setup(root) {
      var toggle = root.querySelector('.crescent-header__nav-toggle');
      var drawer = root.querySelector('.crescent-header__drawer');
      var overlay = root.querySelector('.crescent-header__overlay');
      var closeBtn = root.querySelector('.crescent-header__drawer-close');
      if (!toggle || !drawer) return;

      function open() {
        root.classList.add('crescent-header--nav-open');
        toggle.setAttribute('aria-expanded', 'true');
        drawer.setAttribute('aria-hidden', 'false');
        if (overlay) overlay.hidden = false;
        document.documentElement.style.overflow = 'hidden';
      }
      function close() {
        root.classList.remove('crescent-header--nav-open');
        toggle.setAttribute('aria-expanded', 'false');
        drawer.setAttribute('aria-hidden', 'true');
        document.documentElement.style.overflow = '';
      }

      toggle.addEventListener('click', open);
      if (closeBtn) closeBtn.addEventListener('click', close);
      if (overlay) overlay.addEventListener('click', close);
      document.addEventListener('keyup', function (event) {
        if (event.key === 'Escape' && root.classList.contains('crescent-header--nav-open')) close();
      });

      /* Same-page anchor links (e.g. /#ingredients, /#faq): a nav link otherwise does a native
         jump while the drawer stays open over it and <html> keeps the overflow lock. When a drawer
         link targets an element on the CURRENT page, close() first (releases the lock + overlay),
         then smooth-scroll to it — block:'start' respects the target's scroll-margin-top, and
         prefers-reduced-motion downgrades to an instant jump. Cross-page links (different path or
         query) fall through to native navigation untouched. */
      drawer.addEventListener('click', function (event) {
        var link = event.target.closest('a[href]');
        if (!link || !drawer.contains(link)) return;
        var url = new URL(link.href, window.location.href);
        if (url.pathname !== window.location.pathname || url.search !== window.location.search) return;
        var id = url.hash.slice(1);
        if (!id) return;
        var target = document.getElementById(decodeURIComponent(id));
        if (!target) return;

        event.preventDefault();
        close();
        if (window.history && history.pushState) history.pushState(null, '', url.hash);
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      });
    }
    document.querySelectorAll('.crescent-header').forEach(setup);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  /* Accordion toggle. Event delegation on the document so any number of FAQ section
     instances — including ones added later in the theme editor — work without per-instance
     binding or id collisions. Visibility is driven by aria-expanded + the .is-open class. */
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('.crescent-faq__trigger');
    if (!trigger) return;

    var expanded = trigger.getAttribute('aria-expanded') === 'true';
    trigger.setAttribute('aria-expanded', expanded ? 'false' : 'true');

    var item = trigger.closest('.crescent-faq__item');
    if (item) {
      item.classList.toggle('is-open', !expanded);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredients"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // One rAF-throttled scroll handler drives all three per-scroll updates:
    //   1) focus-scale  — scale up + brighten the active (start-aligned) card
    //   2) active pill  — aria-current on the pill matching the active card
    //   3) progress bar — copper thumb sized to the visible/total ratio and
    //                     moved to scrollLeft (a refined hidden scrollbar).
    // prefers-reduced-motion suppresses ONLY the card scale; the pill + progress
    // state still update (they're indicators, not motion). Re-inits on
    // shopify:section:load for the theme editor.
    var SCALE_MIN = 0.86;   // card scale ~one card-width off the focus point (clamped)
    var OPACITY_MIN = 0.6;  // card opacity ~one card-width off the focus point (clamped)
    var SNAP_TOLERANCE = 4; // px; a resting scrollLeft within this of a card's snap
                            // target counts as "browser snapped correctly" (see the
                            // iOS WebKit-bug-243582 correction in refreshAtRest).
    var CORRECT_MS = 180;   // ms; the iOS snap-correction animation — deliberately
                            // faster than the UA smooth scroll (~300-500ms) so it
                            // doesn't read as a slow second motion after the swipe.

    var reduceMotion = window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Desktop (>=990px) renders a static 3-up grid (see the matching CSS). All the
    // carousel behavior — focus-scale, scroll handling, snap-on-end, scrollToIndex
    // — is gated behind this MQ so none of it runs on the grid. `.matches` is read
    // live and the resize handler re-applies the mode when the breakpoint is crossed.
    var desktop = window.matchMedia('(min-width: 990px)');

    // Desktop grid: strip any focus-scale inline transform/opacity so the cards sit
    // at their normal scale.
    function resetCards(track) {
      var cards = track.children;
      for (var i = 0; i < cards.length; i++) {
        cards[i].style.transform = '';
        cards[i].style.opacity = '';
      }
    }

    function buildContext(track) {
      var root = track.closest('.ingredients') || document;
      return {
        track: track,
        thumb: root.querySelector('.ingredients__progress-thumb'),
        pills: root.querySelectorAll('.ingredients__pill')
      };
    }

    // GPU-friendly: only transform + opacity are written for the scale effect.
    function update(ctx) {
      var track = ctx.track;
      var cards = track.children;
      if (!cards.length) return;
      var box = track.getBoundingClientRect();
      // Focus point = center of the start-aligned (active) card: track left edge
      // + scroll-padding inset + half a card width. Anchoring here (not the track
      // center) keeps the left-pinned card full-size for the left-aligned layout.
      var snapLeft = parseFloat(getComputedStyle(track).scrollPaddingLeft) || 0;
      var focus = box.left + snapLeft + cards[0].getBoundingClientRect().width / 2;

      // 1) focus-scale + find the card nearest the focus point (the active one)
      var activeIndex = 0;
      var activeDist = Infinity;
      for (var i = 0; i < cards.length; i++) {
        var rect = cards[i].getBoundingClientRect();
        if (!rect.width) continue;
        var dist = Math.abs((rect.left + rect.width / 2) - focus);
        if (!reduceMotion) {
          var t = dist / rect.width;          // 0 at focus .. 1 one card-width away
          if (t > 1) t = 1;
          cards[i].style.transform = 'scale(' + (1 - (1 - SCALE_MIN) * t).toFixed(4) + ')';
          cards[i].style.opacity = (1 - (1 - OPACITY_MIN) * t).toFixed(4);
        }
        if (dist < activeDist) { activeDist = dist; activeIndex = i; }
      }

      // 2) active pill — aria-current drives the CSS active state
      if (ctx.pills) {
        for (var p = 0; p < ctx.pills.length; p++) {
          if (p === activeIndex) ctx.pills[p].setAttribute('aria-current', 'true');
          else ctx.pills[p].removeAttribute('aria-current');
        }
      }

      // 3) progress thumb — width = visible/total, left = scroll progress
      if (ctx.thumb) {
        var ratio = track.scrollWidth ? track.clientWidth / track.scrollWidth : 1;
        if (ratio > 1) ratio = 1;
        var maxScroll = track.scrollWidth - track.clientWidth;
        var progress = maxScroll > 0 ? track.scrollLeft / maxScroll : 0;
        var widthPct = ratio * 100;
        ctx.thumb.style.width = widthPct.toFixed(3) + '%';
        ctx.thumb.style.left = (progress * (100 - widthPct)).toFixed(3) + '%';
      }
    }

    // Gutter every card snaps to: scroll-padding-inline-start, with padding
    // fallbacks. scrollToIndex and the swipe-end snapper share this so a tap and a
    // settle agree on where a card lands.
    // Resolve the snap gutter = effective scroll-padding-inline-start, in px. Reading it
    // straight from getComputedStyle is unreliable: when scroll-padding is a
    // calc()/percentage the computed value is an UNRESOLVED string like "calc(-50% + 716px)",
    // so parseFloat returns NaN and the old || chain silently fell through to
    // padding-inline-start — whose % resolves against a DIFFERENT box, so it disagreed with
    // where native snap actually rests. Instead, render the computed length in a throwaway
    // probe whose percentage base is forced to the scrollport width (clientWidth, = the
    // padding box that scroll-padding % resolves against per spec). getBoundingClientRect then
    // reports the browser's own resolved px, identically in Chrome and Firefox.
    function measureGutter(track) {
      var cs = getComputedStyle(track);
      var val = cs.scrollPaddingInlineStart;
      if (!val || val === 'auto') {
        return parseFloat(cs.paddingInlineStart) || parseFloat(cs.paddingLeft) || 0;
      }
      var n = parseFloat(val);
      if (!isNaN(n) && val.indexOf('calc') === -1 && val.indexOf('%') === -1) {
        return n;                       // already a resolved length (e.g. "0px", "196px")
      }
      // Measure in a detached wrapper appended to <body>, NOT inside the track: the track
      // is a scroll-snap flex container, and appending anything to it (even absolutely
      // positioned) must never risk perturbing its children, scrollWidth, or scroll
      // position. The wrapper's fixed width = the scrollport width, so the probe's % still
      // resolves against the same box scroll-padding % uses; vw resolves against the
      // viewport regardless of where the element lives — so the number is identical.
      var wrap = document.createElement('div');
      wrap.style.cssText = 'position:absolute;left:0;top:0;height:0;overflow:hidden;' +
        'visibility:hidden;pointer-events:none;width:' + track.clientWidth + 'px';
      var probe = document.createElement('div');
      probe.style.cssText = 'height:0;width:' + val;
      wrap.appendChild(probe);
      document.body.appendChild(wrap);
      var px = probe.getBoundingClientRect().width;
      document.body.removeChild(wrap);
      return px || 0;
    }

    // Cached accessor — measureGutter touches the DOM, so resolve once and reuse until a
    // resize invalidates it (crossing the breakpoint flips scroll-padding between 0 and a calc).
    function trackGutter(track) {
      if (track.__gutter == null) track.__gutter = measureGutter(track);
      return track.__gutter;
    }

    // Index of the card whose snap target (offsetLeft - gutter) is nearest the current
    // scroll position. Pure helper — used by refreshAtRest's iOS snap-failure check to
    // decide which card SHOULD be resting at the leading slot. NOT a scroll trigger.
    function nearestIndex(track) {
      var cards = track.children;
      var gutter = trackGutter(track);
      var sl = track.scrollLeft;
      var best = 0;
      var bestDist = Infinity;
      for (var i = 0; i < cards.length; i++) {
        var dist = Math.abs((cards[i].offsetLeft - gutter) - sl);
        if (dist < bestDist) { bestDist = dist; best = i; }
      }
      return best;
    }

    // Glide the chosen card to its gutter snap position. Called by pill taps only
    // (swipes now snap natively via CSS scroll-snap). Toggles native snap OFF for
    // the duration of the smooth scroll and restores it on scrollend — otherwise
    // scroll-snap: mandatory yanks the scrollTo mid-animation and pins the card
    // off-start. The target IS the exact snap point, so restoring snap is a no-op
    // (no last-moment hop); the timeout is the no-scrollend fallback.
    // Horizontal-only (never scrolls the page); instant under reduced motion.
    function scrollToIndex(track, index) {
      if (desktop.matches) return;       // grid mode: no programmatic scroll
      var card = track.children[index];
      if (!card) return;
      var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
      var target = card.offsetLeft - trackGutter(track);

      var prevSnap = track.style.scrollSnapType;
      track.style.scrollSnapType = 'none';
      track.scrollTo({ left: target, behavior: reduce ? 'auto' : 'smooth' });

      var restore = function () {
        track.style.scrollSnapType = prevSnap;
        track.removeEventListener('scrollend', restore);
        clearTimeout(t);
      };
      track.addEventListener('scrollend', restore);
      var t = setTimeout(restore, reduce ? 0 : 600);
    }

    // Fast snap correction (iOS WebKit bug 243582 fallback). Animate scrollLeft to
    // `target` over CORRECT_MS with an ease-out curve, driven by rAF. Uses the SAME
    // snap-disable guard as scrollToIndex (scrollSnapType='none' before, restored on
    // completion) so mandatory snap can't fight the per-frame writes; because it lands
    // exactly on the snap point, restoring snap is a no-op. Instant under reduced
    // motion. This is intentionally shorter than scrollToIndex's UA smooth scroll —
    // scrollToIndex is left untouched for pill clicks.
    function correctTo(track, target) {
      var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (track.__correctRaf) cancelAnimationFrame(track.__correctRaf);   // supersede any in-flight correction
      if (!track.__correcting) {                                          // capture the real snap value once
        track.__correcting = true;
        track.__prevSnap = track.style.scrollSnapType;
        track.style.scrollSnapType = 'none';
      }
      var finish = function () {
        track.scrollLeft = target;
        track.style.scrollSnapType = track.__prevSnap;
        track.__correcting = false;
        track.__correctRaf = 0;
      };
      if (reduce) { finish(); return; }
      var start = track.scrollLeft;
      var delta = target - start;
      var t0 = performance.now();
      var step = function (now) {
        var p = (now - t0) / CORRECT_MS;
        if (p >= 1) { finish(); return; }
        track.scrollLeft = start + delta * (1 - Math.pow(1 - p, 3));      // ease-out cubic
        track.__correctRaf = requestAnimationFrame(step);
      };
      track.__correctRaf = requestAnimationFrame(step);
    }

    var resizeBound = false;
    function bindResizeOnce() {
      if (resizeBound) return;
      resizeBound = true;
      window.addEventListener('resize', function () {
        requestAnimationFrame(function () {
          var tracks = document.querySelectorAll('.ingredients__carousel');
          // Re-apply the mode when the breakpoint is crossed: grid -> clear any
          // focus-scale transforms; carousel -> refresh focus-scale + indicators.
          Array.prototype.forEach.call(tracks, function (t) {
            t.__gutter = null;
            if (desktop.matches) resetCards(t);
            else update(buildContext(t));
          });
        });
      }, { passive: true });
    }

    function init(scope) {
      var tracks = (scope || document).querySelectorAll('.ingredients__carousel');
      Array.prototype.forEach.call(tracks, function (track) {
        if (track.dataset.galleryInit) return;   // idempotent per element
        track.dataset.galleryInit = 'true';
        var ctx = buildContext(track);

        var ticking = false;
        var lastSL = track.scrollLeft;   // early snap-settle: last frame's scrollLeft
        var settleFrames = 0;            // consecutive <=1px frames while off-snap
        var touching = false;            // finger-down gate (see earlySnapSettle)
        track.addEventListener('scroll', function () {
          if (desktop.matches) return;   // grid mode: no focus-scale / progress work
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(function () {
            update(ctx);
            ticking = false;
            earlySnapSettle();
          });
        }, { passive: true });

        // Early snap-settle. iOS fires scrollend only after momentum FULLY stops, but
        // the momentum tail crawls ~1px/frame for ~0.5s first (measured on device:
        // ...32,31,31,30,30,30). Rather than wait out that crawl, watch the per-frame
        // scrollLeft delta: once it's been <=1px for 3 straight frames AND we're still
        // off-snap by more than SNAP_TOLERANCE, run the correction now. Reuses correctTo
        // (no second animation path); the scrollend handler stays as the backstop and is
        // a no-op afterward because we've landed within SNAP_TOLERANCE.
        //   - __correcting: never fire during correctTo's own scrollLeft writes.
        //   - touching: never fire mid-drag. Gated on TOUCH state, not pointer events,
        //     because iOS fires pointercancel mid-scroll (finger still down) so pointer
        //     events can't tell "still dragging" from "lifted"; touchend is the reliable
        //     lifted signal, and the momentum we're racing only runs after touchend.
        //     Delta alone is insufficient — a finger held still mid-drag also produces
        //     <=1px frames.
        function earlySnapSettle() {
          if (track.__correcting || touching) { lastSL = track.scrollLeft; settleFrames = 0; return; }
          var sl = track.scrollLeft;
          if (Math.abs(sl - lastSL) <= 1) settleFrames++; else settleFrames = 0;
          lastSL = sl;
          if (settleFrames < 3) return;
          var idx = nearestIndex(track);
          var target = track.children[idx].offsetLeft - trackGutter(track);
          if (Math.abs(sl - target) > SNAP_TOLERANCE) {
            settleFrames = 0;
            correctTo(track, target);
          }
        }
        track.addEventListener('touchstart', function () { touching = true; }, { passive: true });
        ['touchend', 'touchcancel'].forEach(function (e) {
          track.addEventListener(e, function () { touching = false; }, { passive: true });
        });

        Array.prototype.forEach.call(ctx.pills, function (pill) {
          pill.addEventListener('click', function () {
            scrollToIndex(track, parseInt(pill.dataset.index, 10) || 0);
          });
        });

        // Swipe snapping is now native (scroll-snap-type: x mandatory) — the browser
        // retargets momentum in-flight, so no JS swipe-end snapper is needed.

        // Display refresh at rest. The per-scroll handler above is rAF-throttled, so
        // its LAST run can land mid-flight — on iOS Safari the native snap can finish
        // AFTER the final scroll event, leaving the focus-scale transform/opacity
        // frozen at a stale (smaller) value while the card sits at its true snap
        // point. Re-run update() ONCE when the scroll settles, calling it directly so
        // the `ticking` guard can't swallow it. Display state only — no scroll
        // position is written (this is NOT the old snapToNearest). Fallback idle-timer
        // mirrors the pill guard's no-scrollend pattern.
        function refreshAtRest() {
          if (desktop.matches) return;   // grid mode: no focus-scale to refresh
          if (track.__correcting) return; // a correction is mid-animation — its own
                                          // scroll writes fire scrollend; don't let that
                                          // re-enter and restart the glide. The terminal
                                          // scrollend (after __correcting clears) runs update().
          // iOS Safari does not apply scroll-snap to touch-momentum scrolls (WebKit
          // bug 243582), so a finger swipe can rest OFF a snap point. If the settled
          // scrollLeft is NOT within SNAP_TOLERANCE of the nearest card's snap target,
          // the browser failed to snap — glide it there with the existing scrollToIndex
          // (reusing its snap-disable guard). On Chrome/Android native snap already
          // landed on-target, so this branch is skipped and no correction runs. A
          // programmatic scrollTo DOES snap on iOS, so the correction converges (its own
          // scrollend re-enters here within tolerance and just runs update()).
          var idx = nearestIndex(track);
          var target = track.children[idx].offsetLeft - trackGutter(track);
          if (Math.abs(track.scrollLeft - target) > SNAP_TOLERANCE) {
            correctTo(track, target);   // fast rAF glide, not the UA smooth scroll
          }
          update(ctx);
        }
        if ('onscrollend' in window) {
          track.addEventListener('scrollend', refreshAtRest);
        } else {
          var idleRefresh;
          track.addEventListener('scroll', function () {
            clearTimeout(idleRefresh);
            idleRefresh = setTimeout(refreshAtRest, 140);
          }, { passive: true });
        }

        bindResizeOnce();

        // Deterministic start-at-card-0 pin. iOS Safari can re-snap a mandatory-snap
        // track to the WRONG card when an in-track card image decodes AFTER first layout
        // and reflows the content. Pin scrollLeft to 0 now, and re-assert ONCE when the
        // images finish loading (the reflow trigger). Single-shot: the re-assert runs at
        // most once. Any real user gesture (touch / wheel / pill click) permanently
        // disables the pin so it can never fight a user who has scrolled. The only new
        // scroll write is `scrollLeft = 0`; scroll-snap-type is untouched.
        var pinActive = true;
        var reasserted = false;
        function pinToStart() {
          if (!pinActive) return;
          if (track.scrollLeft !== 0) track.scrollLeft = 0;   // no-op when already at 0
        }
        function disablePin() { pinActive = false; }          // interaction kills the pin
        function reassertOnce() {
          if (reasserted) return;                 // at most one re-assert per carousel
          reasserted = true;
          requestAnimationFrame(pinToStart);
        }
        ['touchstart', 'pointerdown', 'wheel'].forEach(function (e) {
          track.addEventListener(e, disablePin, { passive: true });
        });
        Array.prototype.forEach.call(ctx.pills, function (pill) {
          pill.addEventListener('click', disablePin);
        });
        requestAnimationFrame(pinToStart);        // fire 1: after first layout
        // fire 2 (at most once): re-assert when the in-track images finish decoding — the
        // reflow that triggers the mis-snap. The FIRST image to load fires it (they decode
        // together; for a below-fold lazy carousel that's when it's scrolled into view,
        // before which vertical page-scroll hasn't touched the track so the pin is still
        // armed). Tying it to image load — NOT a generic ResizeObserver — keeps a benign
        // font/layout reflow from consuming the single shot ahead of the image reflow.
        var pendingImgs = 0;
        Array.prototype.forEach.call(track.querySelectorAll('img'), function (img) {
          if (!img.complete) {
            pendingImgs++;
            img.addEventListener('load', reassertOnce, { once: true });
            img.addEventListener('error', reassertOnce, { once: true });
          }
        });
        // No images to wait on (all already decoded → no post-layout image reflow): fall
        // back to a single re-assert once fonts settle, covering a font-driven reflow.
        if (pendingImgs === 0 && document.fonts && document.fonts.ready) {
          document.fonts.ready.then(reassertOnce);
        }

        // Initial pass after layout. Carousel: active card full-size, right peek
        // pre-scaled, pills + progress thumb in their starting state. Grid: make
        // sure no focus-scale transforms linger so cards sit at normal scale.
        requestAnimationFrame(function () {
          if (desktop.matches) resetCards(track);
          else update(ctx);
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(document); });
    } else {
      init(document);
    }
    // Theme editor: re-init the section when it's reloaded.
    document.addEventListener('shopify:section:load', function (e) {
      init(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lab-results"] && !Shopify.designMode) return;
  try {
    
  /* Batch list behaviour:
     1. Archive rows are instant accordions (button toggle → panel show/hide), matching the site's
        instant-accordion pattern.
     2. ?batch=<number> deep-link targets BOTH tiers: a hero match highlights the hero; an archive
        match auto-expands that row, then highlights + scrolls. No param / no match = normal render.
        Powers per-batch QR codes. */
  (function () {
    function init() {
      var root = document.querySelector('.lab-results');
      if (!root) return;

      function setRow(toggle, open) {
        var panel = document.getElementById(toggle.getAttribute('aria-controls'));
        toggle.setAttribute('aria-expanded', String(open));
        if (panel) panel.hidden = !open;
      }

      // Instant accordion.
      root.querySelectorAll('.lab-results__archive-toggle').forEach(function (toggle) {
        toggle.addEventListener('click', function () {
          setRow(toggle, toggle.getAttribute('aria-expanded') !== 'true');
        });
      });

      // Highlight + scroll (reduced-motion aware).
      function reveal(highlightEl, scrollEl) {
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        highlightEl.classList.add('is-highlighted');
        window.requestAnimationFrame(function () {
          scrollEl.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        });
      }

      // ?batch= deep-link — hero takes priority (the newest batch also appears in the archive list).
      var params = new URLSearchParams(window.location.search);
      var wanted = params.get('batch');
      if (!wanted) return;
      wanted = wanted.trim().toLowerCase();

      var hero = root.querySelector('.lab-results__batch--hero[data-batch]');
      if (hero && hero.getAttribute('data-batch').trim().toLowerCase() === wanted) {
        reveal(hero, hero);
        return;
      }

      var match = null;
      root.querySelectorAll('.lab-results__archive-row[data-batch]').forEach(function (row) {
        if (row.getAttribute('data-batch').trim().toLowerCase() === wanted) match = row;
      });
      if (!match) return;
      var toggle = match.querySelector('.lab-results__archive-toggle');
      if (toggle) setRow(toggle, true);
      reveal(match, match);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["myths"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // rAF-throttled scroll handler drives: 1) focus-scale on the active card,
    // 2) active-pill aria-current, 3) progress thumb. prefers-reduced-motion
    // suppresses ONLY the card scale (pill + progress still update). Carousel
    // mechanics reused verbatim from sections/ingredients.liquid.
    var SCALE_MIN = 0.86;
    var OPACITY_MIN = 0.6;
    var SNAP_TOLERANCE = 4; // px; a resting scrollLeft within this of a card's snap
                            // target counts as "browser snapped correctly" (see the
                            // iOS WebKit-bug-243582 correction in refreshAtRest).
    var CORRECT_MS = 180;   // ms; the iOS snap-correction animation — deliberately
                            // faster than the UA smooth scroll (~300-500ms) so it
                            // doesn't read as a slow second motion after the swipe.

    var reduceMotion = window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Desktop shows two full cards side by side, so the focus-scale/dim is disabled
    // at >=990px. Read live (.matches) so resizing across the breakpoint updates.
    var desktop = window.matchMedia
      ? window.matchMedia('(min-width: 990px)')
      : { matches: false };

    function buildContext(track) {
      var root = track.closest('.myths') || document;
      return {
        track: track,
        dashes: root.querySelectorAll('.myths__dash')
      };
    }

    // GPU-friendly: only transform + opacity are written for the scale effect.
    function update(ctx) {
      var track = ctx.track;
      var cards = track.children;
      if (!cards.length) return;
      var box = track.getBoundingClientRect();
      var snapLeft = parseFloat(getComputedStyle(track).scrollPaddingLeft) || 0;
      var focus = box.left + snapLeft + cards[0].getBoundingClientRect().width / 2;

      var activeIndex = 0;
      var activeDist = Infinity;
      for (var i = 0; i < cards.length; i++) {
        var rect = cards[i].getBoundingClientRect();
        if (!rect.width) continue;
        var dist = Math.abs((rect.left + rect.width / 2) - focus);
        if (reduceMotion || desktop.matches) {
          // No focus-scale: reduced-motion, or the desktop two-up layout (both cards
          // full). Clear any inline scale/opacity a prior mobile frame wrote (resize).
          cards[i].style.transform = '';
          cards[i].style.opacity = '';
        } else {
          var t = dist / rect.width;
          if (t > 1) t = 1;
          cards[i].style.transform = 'scale(' + (1 - (1 - SCALE_MIN) * t).toFixed(4) + ')';
          cards[i].style.opacity = (1 - (1 - OPACITY_MIN) * t).toFixed(4);
        }
        if (dist < activeDist) { activeDist = dist; activeIndex = i; }
      }

      // At the end of the scroll range the final cards share one position (intentional
      // peek), so the last card can't reach the leading slot — without this the highlight
      // would stick on the second-to-last. Pin the last pill active at max scroll.
      // Resolve the active pill. Priority: a deliberate pill click (override) wins
      // ABSOLUTELY and short-circuits the end-clamp; only WITHOUT an override does the
      // end-clamp pin the last card at max scroll; otherwise it's the focus-based index.
      var override = track.__activeOverride;
      var endMax = track.scrollWidth - track.clientWidth;
      var atEnd = endMax > 0 && track.scrollLeft >= endMax - 1;
      var endClampFired = false;
      if (override != null) {
        activeIndex = override;            // absolute winner — end-clamp skipped
      } else if (atEnd) {
        activeIndex = cards.length - 1;
        endClampFired = true;
      }

      if (ctx.dashes) {
        for (var p = 0; p < ctx.dashes.length; p++) {
          if (p === activeIndex) ctx.dashes[p].setAttribute('aria-current', 'true');
          else ctx.dashes[p].removeAttribute('aria-current');
        }
      }
    }

    // Gutter every card lands at: scroll-padding-inline-start, with padding
    // fallbacks. scrollToIndex and the swipe-end snapper share this.
    // Resolve the snap gutter = effective scroll-padding-inline-start, in px. Reading it
    // straight from getComputedStyle is unreliable: when scroll-padding is a
    // calc()/percentage (the >=990px full-bleed breakout) the computed value is an
    // UNRESOLVED string like "calc(-50% + 716px)", so parseFloat returns NaN and the old
    // || chain silently fell through to padding-inline-start — whose % resolves against a
    // DIFFERENT box, so it disagreed with where native snap actually rests (a 196px gap on
    // desktop that the correction chased forever). Instead, render the computed length in a
    // throwaway probe whose percentage base is forced to the scrollport width (clientWidth,
    // = the padding box that scroll-padding % resolves against per spec). getBoundingClientRect
    // then reports the browser's own resolved px, identically in Chrome and Firefox.
    function measureGutter(track) {
      var cs = getComputedStyle(track);
      var val = cs.scrollPaddingInlineStart;
      if (!val || val === 'auto') {
        return parseFloat(cs.paddingInlineStart) || parseFloat(cs.paddingLeft) || 0;
      }
      var n = parseFloat(val);
      if (!isNaN(n) && val.indexOf('calc') === -1 && val.indexOf('%') === -1) {
        return n;                       // already a resolved length (e.g. "0px", "196px")
      }
      // Measure in a detached wrapper appended to <body>, NOT inside the track: the track
      // is a scroll-snap flex container, and appending anything to it (even absolutely
      // positioned) must never risk perturbing its children, scrollWidth, or scroll
      // position. The wrapper's fixed width = the scrollport width, so the probe's % still
      // resolves against the same box scroll-padding % uses; vw resolves against the
      // viewport regardless of where the element lives — so the number is identical.
      var wrap = document.createElement('div');
      wrap.style.cssText = 'position:absolute;left:0;top:0;height:0;overflow:hidden;' +
        'visibility:hidden;pointer-events:none;width:' + track.clientWidth + 'px';
      var probe = document.createElement('div');
      probe.style.cssText = 'height:0;width:' + val;
      wrap.appendChild(probe);
      document.body.appendChild(wrap);
      var px = probe.getBoundingClientRect().width;
      document.body.removeChild(wrap);
      return px || 0;
    }

    // Cached accessor — measureGutter touches the DOM, so resolve once and reuse until a
    // resize invalidates it (crossing the breakpoint flips scroll-padding between 0 and a calc).
    function trackGutter(track) {
      if (track.__gutter == null) track.__gutter = measureGutter(track);
      return track.__gutter;
    }

    // Index of the card whose snap target (offsetLeft - gutter) is nearest the current
    // scroll position. Pure helper — used by refreshAtRest's iOS snap-failure check to
    // decide which card SHOULD be resting at the leading slot. NOT a scroll trigger.
    function nearestIndex(track) {
      var cards = track.children;
      var gutter = trackGutter(track);
      var sl = track.scrollLeft;
      var best = 0;
      var bestDist = Infinity;
      for (var i = 0; i < cards.length; i++) {
        var dist = Math.abs((cards[i].offsetLeft - gutter) - sl);
        if (dist < bestDist) { bestDist = dist; best = i; }
      }
      return best;
    }

    // Glide the chosen card to its gutter position (offsetLeft - gutter). Called by
    // pill taps only (swipes now snap natively via CSS scroll-snap). Toggles native
    // snap OFF for the duration of the smooth scroll and restores it on scrollend —
    // otherwise scroll-snap: mandatory yanks the scrollTo mid-animation and pins the
    // card off-start. The target IS the exact snap point, so restoring snap is a
    // no-op (no last-moment hop); the timeout is the no-scrollend fallback.
    // Horizontal-only; instant under reduced motion.
    function scrollToIndex(track, index) {
      var card = track.children[index];
      if (!card) return;
      var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
      var target = card.offsetLeft - trackGutter(track);

      var prevSnap = track.style.scrollSnapType;
      track.style.scrollSnapType = 'none';
      track.scrollTo({ left: target, behavior: reduce ? 'auto' : 'smooth' });

      var restore = function () {
        track.style.scrollSnapType = prevSnap;
        track.removeEventListener('scrollend', restore);
        clearTimeout(t);
      };
      track.addEventListener('scrollend', restore);
      var t = setTimeout(restore, reduce ? 0 : 600);
    }

    // Fast snap correction (iOS WebKit bug 243582 fallback). Animate scrollLeft to
    // `target` over CORRECT_MS with an ease-out curve, driven by rAF. Uses the SAME
    // snap-disable guard as scrollToIndex (scrollSnapType='none' before, restored on
    // completion) so mandatory snap can't fight the per-frame writes; because it lands
    // exactly on the snap point, restoring snap is a no-op. Instant under reduced
    // motion. This is intentionally shorter than scrollToIndex's UA smooth scroll —
    // scrollToIndex is left untouched for pill clicks.
    function correctTo(track, target) {
      var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (track.__correctRaf) cancelAnimationFrame(track.__correctRaf);   // supersede any in-flight correction
      if (!track.__correcting) {                                          // capture the real snap value once
        track.__correcting = true;
        track.__prevSnap = track.style.scrollSnapType;
        track.style.scrollSnapType = 'none';
      }
      var finish = function () {
        track.scrollLeft = target;
        track.style.scrollSnapType = track.__prevSnap;
        track.__correcting = false;
        track.__correctRaf = 0;
      };
      if (reduce) { finish(); return; }
      var start = track.scrollLeft;
      var delta = target - start;
      var t0 = performance.now();
      var step = function (now) {
        var p = (now - t0) / CORRECT_MS;
        if (p >= 1) { finish(); return; }
        track.scrollLeft = start + delta * (1 - Math.pow(1 - p, 3));      // ease-out cubic
        track.__correctRaf = requestAnimationFrame(step);
      };
      track.__correctRaf = requestAnimationFrame(step);
    }

    var resizeBound = false;
    function bindResizeOnce() {
      if (resizeBound) return;
      resizeBound = true;
      window.addEventListener('resize', function () {
        requestAnimationFrame(function () {
          var tracks = document.querySelectorAll('.myths__carousel');
          Array.prototype.forEach.call(tracks, function (t) { t.__gutter = null; update(buildContext(t)); });
        });
      }, { passive: true });
    }

    function init(scope) {
      var tracks = (scope || document).querySelectorAll('.myths__carousel');
      Array.prototype.forEach.call(tracks, function (track) {
        if (track.dataset.galleryInit) return;   // idempotent per element
        track.dataset.galleryInit = 'true';
        var ctx = buildContext(track);

        var ticking = false;
        var lastSL = track.scrollLeft;   // early snap-settle: last frame's scrollLeft
        var settleFrames = 0;            // consecutive <=1px frames while off-snap
        var touching = false;            // finger-down gate (see earlySnapSettle)
        track.addEventListener('scroll', function () {
          // NOTE: the override is NOT cleared here. The programmatic snap from a pill
          // click fires its own scroll events (scrollToIndex's smooth scrollTo), so
          // clearing the override in this handler would wipe it mid-settle. It's released
          // on a real user gesture instead (pointerdown/touch/wheel below), so it
          // survives its own snap.
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(function () {
            update(ctx);
            ticking = false;
            earlySnapSettle();
          });
        }, { passive: true });

        // Early snap-settle. iOS fires scrollend only after momentum FULLY stops, but
        // the momentum tail crawls ~1px/frame for ~0.5s first (measured on device:
        // ...32,31,31,30,30,30). Rather than wait out that crawl, watch the per-frame
        // scrollLeft delta: once it's been <=1px for 3 straight frames AND we're still
        // off-snap by more than SNAP_TOLERANCE, run the correction now. Reuses correctTo
        // (no second animation path); the scrollend handler stays as the backstop and is
        // a no-op afterward because we've landed within SNAP_TOLERANCE.
        //   - __correcting: never fire during correctTo's own scrollLeft writes.
        //   - touching: never fire mid-drag. Gated on TOUCH state, not pointer events,
        //     because iOS fires pointercancel mid-scroll (finger still down) so pointer
        //     events can't tell "still dragging" from "lifted"; touchend is the reliable
        //     lifted signal, and the momentum we're racing only runs after touchend.
        //     Delta alone is insufficient — a finger held still mid-drag also produces
        //     <=1px frames.
        function earlySnapSettle() {
          if (desktop.matches) return;   // >=990px: native snap manages the two-up carousel; no JS correction
          if (track.__correcting || touching) { lastSL = track.scrollLeft; settleFrames = 0; return; }
          var sl = track.scrollLeft;
          if (Math.abs(sl - lastSL) <= 1) settleFrames++; else settleFrames = 0;
          lastSL = sl;
          if (settleFrames < 3) return;
          var idx = nearestIndex(track);
          var target = track.children[idx].offsetLeft - trackGutter(track);
          if (Math.abs(sl - target) > SNAP_TOLERANCE) {
            settleFrames = 0;
            correctTo(track, target);
          }
        }
        track.addEventListener('touchstart', function () { touching = true; }, { passive: true });
        ['touchend', 'touchcancel'].forEach(function (e) {
          track.addEventListener(e, function () { touching = false; }, { passive: true });
        });

        // A genuine user gesture ON THE TRACK (drag / swipe / wheel) releases the pill
        // override so scroll-based highlighting resumes. Pills live OUTSIDE the track,
        // so a pill click never triggers these — the override outlives its own snap.
        ['pointerdown', 'touchstart', 'wheel'].forEach(function (evt) {
          track.addEventListener(evt, function () {
            track.__activeOverride = null;
          }, { passive: true });
        });

        Array.prototype.forEach.call(ctx.dashes, function (dash) {
          dash.addEventListener('click', function () {
            var index = parseInt(dash.dataset.index, 10) || 0;
            // A deliberate click wins: pin THIS dash active even though the last cards share
            // the end scroll-position. Released only by a user gesture on the track.
            track.__activeOverride = index;
            scrollToIndex(track, index);
            // Apply the override NOW: if the target equals the current scroll position
            // (e.g. the last dash when already at the end) no scroll event fires, so update()
            // wouldn't otherwise run and the dash wouldn't refresh.
            update(ctx);
          });
        });

        // Swipe snapping is now native (scroll-snap-type: x mandatory) — the browser
        // retargets momentum in-flight, so no JS swipe-end snapper is needed.

        // Display refresh at rest. The per-scroll handler above is rAF-throttled, so
        // its LAST run can land mid-flight — on iOS Safari the native snap can finish
        // AFTER the final scroll event, leaving the focus-scale transform/opacity
        // frozen at a stale (smaller) value while the card sits at its true snap
        // point. Re-run update() ONCE when the scroll settles, calling it directly so
        // the `ticking` guard can't swallow it. Display state only — no scroll
        // position is written (this is NOT the old snapToNearest). Fallback idle-timer
        // mirrors the pill guard's no-scrollend pattern.
        function refreshAtRest() {
          if (desktop.matches) return;   // >=990px: native snap manages snapping; the scrollend
                                          // backstop (and its correctTo) must not run here. update()
                                          // still runs every scroll frame (handler is not gated), so
                                          // desktop pills/progress keep tracking.
          if (track.__correcting) return; // a correction is mid-animation — its own
                                          // scroll writes fire scrollend; don't let that
                                          // re-enter and restart the glide. The terminal
                                          // scrollend (after __correcting clears) runs update().
          // iOS Safari does not apply scroll-snap to touch-momentum scrolls (WebKit
          // bug 243582), so a finger swipe can rest OFF a snap point. If the settled
          // scrollLeft is NOT within SNAP_TOLERANCE of the nearest card's snap target,
          // the browser failed to snap — glide it there with the existing scrollToIndex
          // (reusing its snap-disable guard). On Chrome/Android native snap already
          // landed on-target, so this branch is skipped and no correction runs. A
          // programmatic scrollTo DOES snap on iOS, so the correction converges (its own
          // scrollend re-enters here within tolerance and just runs update()).
          var idx = nearestIndex(track);
          var target = track.children[idx].offsetLeft - trackGutter(track);
          if (Math.abs(track.scrollLeft - target) > SNAP_TOLERANCE) {
            correctTo(track, target);   // fast rAF glide, not the UA smooth scroll
          }
          update(ctx);
        }
        if ('onscrollend' in window) {
          track.addEventListener('scrollend', refreshAtRest);
        } else {
          var idleRefresh;
          track.addEventListener('scroll', function () {
            clearTimeout(idleRefresh);
            idleRefresh = setTimeout(refreshAtRest, 140);
          }, { passive: true });
        }

        bindResizeOnce();

        // Deterministic start-at-card-0 pin. iOS Safari can re-snap a mandatory-snap
        // track to the WRONG card when an in-track card image decodes AFTER first layout
        // and reflows the content. Pin scrollLeft to 0 now, and re-assert ONCE when the
        // images finish loading (the reflow trigger). Single-shot: the re-assert runs at
        // most once. Any real user gesture (touch / wheel / pill click) permanently
        // disables the pin so it can never fight a user who has scrolled. The only new
        // scroll write is `scrollLeft = 0`; scroll-snap-type is untouched.
        var pinActive = true;
        var reasserted = false;
        function pinToStart() {
          if (!pinActive) return;
          if (track.scrollLeft !== 0) track.scrollLeft = 0;   // no-op when already at 0
        }
        function disablePin() { pinActive = false; }          // interaction kills the pin
        function reassertOnce() {
          if (reasserted) return;                 // at most one re-assert per carousel
          reasserted = true;
          requestAnimationFrame(pinToStart);
        }
        ['touchstart', 'pointerdown', 'wheel'].forEach(function (e) {
          track.addEventListener(e, disablePin, { passive: true });
        });
        Array.prototype.forEach.call(ctx.dashes, function (dash) {
          dash.addEventListener('click', disablePin);
        });
        requestAnimationFrame(pinToStart);        // fire 1: after first layout
        // fire 2 (at most once): re-assert when the in-track images finish decoding — the
        // reflow that triggers the mis-snap. The FIRST image to load fires it (they decode
        // together; for a below-fold lazy carousel that's when it's scrolled into view,
        // before which vertical page-scroll hasn't touched the track so the pin is still
        // armed). Tying it to image load — NOT a generic ResizeObserver — keeps a benign
        // font/layout reflow from consuming the single shot ahead of the image reflow.
        var pendingImgs = 0;
        Array.prototype.forEach.call(track.querySelectorAll('img'), function (img) {
          if (!img.complete) {
            pendingImgs++;
            img.addEventListener('load', reassertOnce, { once: true });
            img.addEventListener('error', reassertOnce, { once: true });
          }
        });
        // No images to wait on (all already decoded → no post-layout image reflow): fall
        // back to a single re-assert once fonts settle, covering a font-driven reflow.
        if (pendingImgs === 0 && document.fonts && document.fonts.ready) {
          document.fonts.ready.then(reassertOnce);
        }

        requestAnimationFrame(function () { update(ctx); });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(document); });
    } else {
      init(document);
    }
    // Theme editor: re-init the section when it's reloaded.
    document.addEventListener('shopify:section:load', function (e) {
      init(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
  /* Mobile collapse toggle for the review control bar. Event delegation on the
     document so any number of section instances — including ones added later in
     the theme editor — work without per-instance binding or id collisions. The
     panel's visibility is driven purely by the button's aria-expanded state in CSS. */
  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('.crescent-reviews__controls-toggle');
    if (!toggle) return;
    var expanded = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
  });

  } catch(e) { console.error(e); }
})();
})();
